import React from 'react'
import landmark from '../../assets/images/landmark.svg'
export const Rewardslogo = () => {
    
    return (
        <div className= "grid place-items-center bg-yellow-500 h-40 w-80 mx-auto font-roboto rounded-lg mt-6 ">
            {/* <img className="mt-4" src={landmark}/> */}
            <img className="mt-4 w-64 " src={landmark}/>
        </div>

        
    )
}
